<script setup lang="ts">
import TicketCreatePage from '@/components/TicketComponents/TicketCreatePage.vue'
import { TECHNICIAN_TICKETS_ROUTES } from '@/router/routing/technicianRouting/technicianRoutes'
</script>

<template>
    <TicketCreatePage
        :editButtonHref="TECHNICIAN_TICKETS_ROUTES.baseUrl"
        :createButtonHref="TECHNICIAN_TICKETS_ROUTES.createUrl"
        canCreateTopic />
</template>
